import styled from "styled-components";

export const DropBody = styled.div`
  padding: 1em 2em 1.5em;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
`;
